import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  text: ({
    fontFamily,
    fontSize,
    color,
    fontWeight,
    textAlign,
    lineHeight,
    opacity,
    m,
    mt,
    mb,
    mr,
    ml,
    textTransform,
    wordBreak,
    textDecoration,
    whiteSpace,
  }) => ({
    fontSize: fontSize ?? '0.875rem',
    color: color ?? '#7D86A9',
    fontFamily: fontFamily ?? 'NotoSans-Medium',
    fontWeight: fontWeight ?? '500',
    lineHeight: lineHeight ?? 'normal',
    textAlign: textAlign ?? 'start',
    opacity,
    margin: m,
    marginTop: mt,
    marginRight: mr,
    marginBottom: mb,
    marginLeft: ml,
    textTransform,
    wordBreak,
    textDecoration,
    whiteSpace,
  }),
}));

const Text = ({
  children,
  fontFamily = 'NotoSans-Medium',
  fontSize = '0.875rem',
  color = '#7D86A9',
  fontWeight = '500',
  textAlign = 'start',
  lineHeight,
  opacity = '1',
  m = '0',
  mt = '0',
  mb = '0',
  mr = '0',
  ml = '0',
  style = {},
  textTransform = 'none',
  wordBreak = 'normal',
  textDecoration = 'none',
  whiteSpace = 'normal',
}) => {
  const classes = useStyles({
    fontFamily,
    fontSize,
    color,
    fontWeight,
    textAlign,
    lineHeight,
    opacity,
    m,
    mt,
    mb,
    mr,
    ml,
    textTransform,
    wordBreak,
    textDecoration,
    whiteSpace,
  });

  return (
    <div className={classes.text} style={style}>
      {children}
    </div>
  );
};

export default Text;
